// src/services/inspectorAPI.js
import api from './api'; // reuse existing axios instance

const inspectorAPI = {
  // ── Inspections ──────────────────────────────────────────────────────────
  getInspections: () =>
    api.get('/inspector/car_inspections'),

  getInspection: (id) =>
    api.get(`/inspector/car_inspections/${id}`),

  updateInspection: (id, data) =>
    api.patch(`/inspector/car_inspections/${id}`, data),

  // ── Inspection Items ──────────────────────────────────────────────────────
  createInspectionItem: (inspectionId, data) =>
    api.post(`/inspector/car_inspections/${inspectionId}/inspection_items`, data),

  updateInspectionItem: (inspectionId, itemId, data) =>
    api.patch(
      `/inspector/car_inspections/${inspectionId}/inspection_items/${itemId}`,
      data
    ),

  // ── Photos ────────────────────────────────────────────────────────────────
  uploadPhotos: (inspectionId, photos) => {
    const formData = new FormData();
    photos.forEach((photo) => formData.append('photos[]', photo));
    return api.post(
      `/inspector/car_inspections/${inspectionId}/inspection_images`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },

  // ── Inspection Report ─────────────────────────────────────────────────────
  // Rails singular resource  →  /inspection_report  (no :id in URL)
  createInspectionReport: (inspectionId, data) =>
    api.post(
      `/inspector/car_inspections/${inspectionId}/inspection_report`,
      data
    ),

  updateInspectionReport: (inspectionId, data) =>
    api.patch(
      `/inspector/car_inspections/${inspectionId}/inspection_report`,
      data
    ),
};

export default inspectorAPI;